import TableOptions from './TableOptions';

export default TableOptions;



// WEBPACK FOOTER //
// ./src/components/Building/Chess/TableOptions/index.js